{ useI18n } = require 'lib/react_utils'

IDSA_TEXTAREAS = [
  "activity",
  "company_organization",
  "date_end",
  "does_the_company_have_product",
  "is_the_sponsor_product",
  "end",
  "sponsor_founder",
  "have_you_sold",
  "ip_description",
  "position",
  "project_study_title",
  "role_description",
  "value",
  "briefly_describe_your_role_investigator",
  "in_addition_to_financial_compensation",
  "was_this_activity_directly_funded"
]

IDSA_CHECKBOXES = [
  'regulatory_government_body',
  'non_government_body',
]

IDSA_SELECTS = {
  compensation_range: [
    "unpaid",
    "i_do_not_know",
    "0-5000",
    "5001-10000",
    "10001-25000",
    "25001+",
  ],
  divest_until_guideline_is_published: [
    "yes",
    "no",
    "na",
  ],
  specify_division_of_the_company: [
    "research_arm",
    "marketing_arm",
    "both",
  ],
  equity_type: [
    "stock",
    "stock_options",
    "other",
  ],
  holder_of_rights: [
    "self",
    "institution",
    "other",
  ],
  ip_associated_with_publications: [
    "yes",
    "no",
  ],
  ip_financial_benefit: [
    "yes",
    "no",
  ],
  ip_type: [
    "patent",
    "copyright",
    "license",
    "trademark",
    "other",
  ],
  is_the_company_product_related: [
    "yes",
    "no",
  ],
  is_the_holding_part_of_a_diversified_fund: [
    "yes",
    "no",
  ],
  is_the_ip_related_to_the_topic: [
    "yes",
    "no",
  ],
  position_held: [
    "board_member",
    "officer",
    "partner",
    "trustee",
    "other",
  ],
  recipient_of_compensation: [
    "self",
    "institution",
  ],
  recipient_of_funds: [
    "self",
    "institution",
  ],
  relationships: [
    "spouse",
    "domestic_partner",
    "child",
    "other_dependent",
  ],
  specify_division_of_the_company_funding_this_interest: [
    "na",
    "research_arm",
    "marketing_arm",
    "both",
  ],
  value_range: [
    "0-5000",
    "5001-10000",
    "10001-25000",
    "25001+",
  ],
  perceived_relevance: [
    "yes",
    "no",
  ],
  was_the_content_provided: [
    "yes",
    "no",
  ],
  was_there_intellectual_independence:[
    "yes",
    "no"
  ],
  was_the_presentation_product_specific:[
    "yes",
    "no"
  ],
  was_this_presentation_promotional:[
    "yes",
    "no"
  ]
}

AnswerValue = ({answer, field}) ->
  i18n = useI18n("team:coi")

  if field in IDSA_TEXTAREAS
    answer[field]
  else if field in Object.keys(IDSA_SELECTS)
    answer[field] and i18n("select_options.#{field}.#{answer[field]}")
  else if field is 'consent'
    !!answer['consent']
  else
    answer['value'] ? ''

IDSAAnswers = ({ answers }) ->
  i18n = useI18n("team:coi")

  <div>
    {_.map answers, (answersGroup) ->
      { title, inputType } = _.first(answersGroup)
      dasherizedTitle = _.str.dasherize title
      <div key={_.str.dasherize title} className="mb-10">
        <b>{title}</b>
        {switch inputType
          when 'customRegulatoryInputType'
            answersGroup.map (answer) ->
              <CheckboxesAnswer
                answer={answer}
                title={title}
              />
          when 'multiRowCompanyTable'
            <TabularAnswer
              answers={answersGroup}
              fields={[
                'company_organization',
                'does_the_company_have_product',
                'specify_division_of_the_company',
                'date_end',
                'position',
                'recipient_of_compensation',
                'compensation_range',
                'in_addition_to_financial_compensation',
                'divest_until_guideline_is_published'
              ]}
              title={title}
            />
          when 'multiRowSpeakingPresentationsTable'
            <TabularAnswer
              answers={answersGroup}
              fields={[
                'company_organization',
                'does_the_company_have_product',
                'date_end',
                'was_this_presentation_promotional',
                'was_the_content_provided',
                'was_there_intellectual_independence',
                'was_the_presentation_product_specific',
                'was_this_activity_directly_funded',
                'compensation_range',
                'recipient_of_compensation',
                'in_addition_to_financial_compensation'
              ]}
              title={title}
            />
          when 'multiRowGrantsResearchTable'
            <TabularAnswer
              answers={answersGroup}
              fields={[
                "sponsor_founder",
                "is_the_sponsor_product",
                "date_end",
                "specify_division_of_the_company_funding_this_interest",
                "project_study_title",
                "briefly_describe_your_role_investigator",
                "recipient_of_funds",
                "compensation_range",
                "in_addition_to_financial_compensation",
                "divest_until_guideline_is_published",
              ]}
              title={title}
            />
          when 'multiRowStockEquityTable'
            <TabularAnswer
              answers={answersGroup}
              fields={[
                "company_organization",
                "does_the_company_have_product",
                "is_the_holding_part_of_a_diversified_fund",
                "equity_type",
                "value_range",
                "have_you_sold",
                "divest_until_guideline_is_published",
              ]}
              title={title}
            />
          when 'multiRowIntellectualPropertyTable'
            <TabularAnswer
              answers={answersGroup}
              fields={[
                "ip_type",
                "ip_description",
                "is_the_ip_related_to_the_topic",
                "holder_of_rights",
                "ip_financial_benefit",
                "ip_associated_with_publications",
                "divest_until_guideline_is_published",
              ]}
              title={title}
            />
          when 'multiRowFiduciaryRolesTable'
            <TabularAnswer
              answers={answersGroup}
              fields={[
                "company_organization",
                "position_held",
                "does_the_company_have_product",
                "compensation_range",
                "in_addition_to_financial_compensation",
                "date_end",
                "divest_until_guideline_is_published",
              ]}
              title={title}
            />
          when 'multiRowRelationshipsTable'
            <TabularAnswer
              answers={answersGroup}
              fields={[
                "relationships",
                "company_organization",
                "is_the_company_product_related",
                "activity",
                "date_end",
                "compensation_range",
                "recipient_of_compensation",
                "in_addition_to_financial_compensation",
                "divest_until_guideline_is_published",
              ]}
              title={title}
            />
          when 'multiRowOtherTable'
            <TabularAnswer
              answers={answersGroup}
              fields={[
                "company_organization",
                "activity",
                "role_description",
                "perceived_relevance",
              ]}
              title={title}
            />
          else
            _.map answersGroup, (answer) ->
              { inputType, isConflict, value, consent, client, description } = answer
              <div>
                {switch inputType
                  when 'textarea'
                    <div>{value}</div>
                  when 'checkbox'
                    if consent then i18n 'yes' else i18n 'no'
                  when 'titleYesNoTextarea'
                    <div>
                      <strong>{if isConflict then i18n('yes') else i18n('no')}</strong>
                      {isConflict and value and <div className="mt-5">{value}</div>}
                    </div>
                  else
                    <div>{value}</div>
                }
              </div>
          }
      </div>
    }
  </div>

CheckboxesAnswer = ({ answer, title }) ->
  i18n = useI18n("team:coi")

  checkboxes = _.compact Object.keys(answer).map (key) ->
    { text: i18n("idsa_form.#{key}"), value: answer[key] } if key in IDSA_CHECKBOXES

  <div className="checkboxes-answer">
    {checkboxes.map ({ text, value }, index) ->
      <div key={index} className="mr-20">{value && <strong>✓</strong>}{text}</div>
    }
  </div>

TabularAnswer = ({ answers, fields, title }) ->
  i18n = useI18n("team:coi")
  <table key={_.str.dasherize title} className="mb-10 standard-table">
    <thead>
      <tr>
        {fields.map((field) ->
          <th key={field}>{i18n "idsa_form.#{field}"}</th>
        )}
      </tr>
    </thead>
    <tbody>
      {answers.map((answer, index) ->
        <tr key={index}>
          {fields.map((field) ->
            <td key={field}><AnswerValue answer={answer} field={field} /></td>
          )}
        </tr>
      )}
    </tbody>
  </table>

module.exports = IDSAAnswers
